const state ={
  currentProduct:{},
  products:{},
  desc:'产品列表'
}
const mutations = {}
const actions = {}
const getters={}
export default {
  state,
  mutations,
  actions,
  getters
}